import { Component, computed, input, output } from '@angular/core'

@Component({
   selector: 'vc-dropdown-button',
   templateUrl: './dropdown-button.component.html',
   styleUrl: './dropdown-button.component.scss',
   standalone: true,
})
export class DropdownButtonComponent {
   defaultLabel = input<string>()
   selectedItemId = input<any>()
   items = input<any[]>()
   idSelector = input<string>()
   textSelector = input<string>()

   _internalId = `dropdown-${Math.random() * 1000}`

   itemSelected = output<any>()

   selectedItem = computed(() => this.items().find((i) => i[this.idSelector()] === this.selectedItemId()))

   ngOnInit() {}

   onItemSelected(item: any) {
      this.itemSelected.emit(item)
   }
}
